import type { SlaterList } from "../list.js";

/**
 * Load more — offset pagination for a list or search block.
 *
 * The `[data-slater-load-more]` button appends the next page instead of
 * re-rendering, so scroll position is kept. Hiding the button once everything
 * is shown lives in core (`updateChrome`), since it is driven by every load.
 */

export function bindLoadMore(list: SlaterList): void {
  const el = list.loadMoreEl;
  el?.addEventListener("click", (event) => {
    event.preventDefault();
    void loadMore(list);
  });
}

export async function loadMore(list: SlaterList): Promise<void> {
  const offset = list.state.visibleCount;
  if (offset >= list.total) return;
  list.state.visibleCount += list.config.loadMoreAmount;
  const ok = await list.load("append", offset, list.config.loadMoreAmount);
  // Roll the counter back on failure, or the next click would skip a page.
  if (!ok) list.state.visibleCount = offset;
}
